import { RefundMethodType } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { TextView } from '@dreryk/react-components';
import { createTranslatedText, Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentRefundMethodTypeTextViewProps = Readonly<{ refundMethodType: RefundMethodType | null | undefined }>;

export const AdvancePaymentRefundMethodTypeTextView = (
   props: AdvancePaymentRefundMethodTypeTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'refundMethodType'} label={translationKeys.advancePaymentRefundMethodType}>
         <Translate>
            {props.refundMethodType
               ? translationKeys.refundMethodTypeMap[props.refundMethodType]
               : createTranslatedText(EMPTY_PLACEHOLDER)}
         </Translate>
      </TextView>
   );
};
